import {
  Box,
  Col,
  H1,
  HeroAmount,
  ShortSplitter,
  Span,
} from '@landsbankinn/ui-kit';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { type ScopeData } from '../../../state/server';
import { useConsentClientContext } from '../State/consentClientState';
import { getLocalizedString, groupBy } from '../utils';
import { FooterWithButtons } from './FooterWithButtons';
import { Groups } from './Groups';
import { MobileTitleAndDescription } from './MobileTitleAndDescription';

export function ScopeDataView(props: {
  data: ScopeData[];
  previousTitle: string;
  nextTitle: string;
  isLastView: boolean;
  onPrevious: () => void;
  onNext: () => void;
}) {
  const { isMobile } = useScreenSize();
  const [consentClient] = useConsentClientContext();

  const hero = consentClient.hero;
  const groups = groupBy(props.data, 'group');

  return (
    <Col
      paddingTop={isMobile ? '60' : undefined}
      paddingHorizontal={isMobile ? '36' : undefined}
      color="blue font"
      background="blue baseLight"
      grow="1"
    >
      <Col grow="1">
        {isMobile && hero && (
          <>
            <H1 fontVariant="h4">
              {consentClient.localization?.title ?? hero.localized_name}
            </H1>
            <ShortSplitter height="32" />
            <HeroAmount
              fontSize="60"
              currency={hero.label ?? 'ISK'}
              type="currency"
              value={hero.value}
            />
            <Span fontVariant="table">{hero.localized_name}</Span>
            <Box height="56" />
          </>
        )}
        {isMobile && !hero && (
          <MobileTitleAndDescription
            paddingHorizontal="0"
            title={
              getLocalizedString('title', consentClient.localization) ?? ''
            }
            description={getLocalizedString(
              'description',
              consentClient.localization,
            )}
          />
        )}

        <Groups data={groups} />
      </Col>

      <FooterWithButtons
        previousTitle={props.previousTitle}
        nextTitle={props.nextTitle}
        isConfirm={props.isLastView}
        onNext={() => {
          props.onNext();
        }}
        onPrevious={() => {
          props.onPrevious();
        }}
      />
    </Col>
  );
}
